module.exports = __webpack_public_path__ + "09e9c4089754afc8936f237ff982c237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/bg_2.png
// module id = 243
// module chunks = 1